module.exports = __webpack_public_path__ + "/images/ico-vendedores-globe.df7d883.svg";